import React from "react";
import ReactPaginate from "react-paginate";
import Icon from "../atoms/Icon";

const Pagination = ({ changePage, countAll, currentPage }) => {
  // Define the number of users per page
  const userPerPage = 10;
  // Calculate the total number of pages based on the total count of users and users per page
  const pageCount = Math.ceil(countAll / userPerPage);
  // Calculate the start index of the displayed range
  const startIndex = (currentPage - 1) * userPerPage + 1;
  // Calculate the end index of the displayed range, ensuring it doesn't exceed the total count of users
  const endIndex = Math.min(startIndex + userPerPage - 1, countAll);
  return (
    <div dir="ltr" className="flex items-end justify-between">
      {/* Render pagination only if there is more than one page */}
      {pageCount > 1 && (
        <>
          {/* ReactPaginate component for pagination */}
          <ReactPaginate
            breakLabel={"..."}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            forcePage={currentPage - 1}
            className="flex flex-row-reverse items-center mt-7.5px gap-2.5"
            pageCount={pageCount}
            previousLabel={<Icon iconName="arrow-rightD" />}
            nextLabel={<Icon iconName="arrow-leftD" />}
            onPageChange={changePage}
            pageClassName="rounded-full border-gray border-1 h-8.5 w-8.5 text-13 text-dark-blue-200 bg-gray-100"
            containerClassName={""}
            previousLinkClassName={
              "rounded-full border-gray border-1 h-8.5 w-8.5 flex items-center justify-center text-13 text-dark-blue-200 bg-gray-100"
            }
            nextLinkClassName={
              "rounded-full border-gray border-1 h-8.5 w-8.5 flex items-center justify-center text-13 text-dark-blue-200 bg-gray-100"
            }
            pageLinkClassName={"w-full text-center flex items-center justify-center h-full"}
            activeClassName={"border-1 border-blue "}
          />
          {/* Display the range of displayed data */}
          <p className="text-13 text-gray_L leading-5 word-spacing">
            نمایش {startIndex} تا {endIndex} از {countAll} ردیف داده
          </p>
        </>
      )}
    </div>
  );
};

export default Pagination;
